enum QsrAutomationsDepartmentKey {
  SectionBiteId = 'section-bite-id',
  SectionInternalName = 'section-internal-name',
}

export { QsrAutomationsDepartmentKey };
